/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BillingChangePreviewResponseCadence } from './billingChangePreviewResponseCadence';
import type { BillingChangePreviewResponseCurrentCadence } from './billingChangePreviewResponseCurrentCadence';

export interface BillingChangePreviewResponse {
  currency?: string;
  current_plan_name?: string;
  plan_name: string;
  current_cadence: BillingChangePreviewResponseCurrentCadence;
  cadence: BillingChangePreviewResponseCadence;
  current_seats: number;
  seat_count: number;
  current_recurring_cents: number;
  new_recurring_cents: number;
  renewal_at?: string | null;
  amount_due_today_cents: number;
  current_credits_per_cycle: number;
  new_credits_per_cycle: number;
  prorated_credit_delta: number;
}
